var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_602_435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 5.84619V9.17331H1.4644V7.31059H29.042V9.17331H30.5064V5.84619H0Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.4429 29.7394H18.4983V24.1102H12.0081V29.7394H3.06352V9.99927H1.59912V31.2038H12.0081H18.4983H28.9073V9.99927H27.4429V29.7394Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.9093 11.6863H6.08008V13.1507H8.9093V11.6863Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.6705 11.6863H13.8413V13.1507H16.6705V11.6863Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4323 11.6863H21.603V13.1507H24.4323V11.6863Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.9093 15.9858H6.08008V17.4502H8.9093V15.9858Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M16.6705 15.9858H13.8413V17.4502H16.6705V15.9858Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.4323 15.9858H21.603V17.4502H24.4323V15.9858Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.9093 20.2852H6.08008V21.7496H8.9093V20.2852Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M16.6705 20.2852H13.8413V21.7496H16.6705V20.2852Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M24.4323 20.2852H21.603V21.7496H24.4323V20.2852Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.9093 24.5789H6.08008V26.0433H8.9093V24.5789Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M24.4323 24.5789H21.603V26.0433H24.4323V24.5789Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M3.06352 4.60453H27.4429H27.9349H28.9073V0.69751H1.59912V4.60453H2.33132H3.06352Z",
    fill: "#494949"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.5064,
    height: 30.5064,
    fill: "white",
    transform: "translate(0 0.69751)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.3820a8136df366a908d312207b2c7820.svg";
export { ForwardRef as ReactComponent };